<div [formGroup]="reformaForm">

    <!-- ── Info: obrigatoriedade / entidades compartilhadas ───────────────── -->
    <app-alert-card
        class="reforma-info"
        type="info"
        title="Reforma Tributária (IBS/CBS/IS)"
        icon="info">
        É obrigatória a partir de 1º de agosto de 2026. As classificações abaixo são
        entidades compartilhadas — editá-las afeta todas as naturezas de operação que
        as relacionam.
    </app-alert-card>

    <!-- ── Ativação ───────────────────────────────────────────────────────── -->
    <app-ativacao-section-card
        [control]="isAtivoControl"
        titulo="Reforma Tributária"
        descricaoAtivo="Reforma Tributária ativa. O motor aplica a regra padrão e as regras relacionadas a todos os itens desta natureza de operação."
        descricaoInativo="Reforma Tributária inativa. O motor ignora IBS, CBS e IS no cálculo desta natureza de operação."
        emptyStateTitulo="Reforma Tributária desativada"
        emptyStateDescricao="Ative a Reforma Tributária acima para vincular a regra padrão e as regras tributárias relacionadas.">
    </app-ativacao-section-card>

    @if (isAtivoControl.value) {

    <!-- ── Regra Padrão ───────────────────────────────────────────────── -->
    <app-reforma-tributo-regra-section
        [regra]="regraPadrao"
        [pendente]="regraPadraoPendente"
        [nomeModeloPorCodigo]="nomeModeloPorCodigo"
        (selecionarRegra)="abrirSelecionarRegraPadrao()"
        (cadastrarRegra)="cadastrarNovaRegra()"
        (editarRegra)="editarRegra($event)"
        (removerRegra)="removerRegraPadrao()">
    </app-reforma-tributo-regra-section>

    <!-- ── Regras Tributárias Relacionadas ────────────────────────────── -->
    <app-reforma-tributo-regras-relacionadas-section
        [regrasRelacionadas]="regrasRelacionadas"
        [nomeModeloPorCodigo]="nomeModeloPorCodigo"
        (relacionar)="abrirRelacionarRegras()"
        (editarRegra)="editarRegra($event)"
        (removerRegra)="removerRegraRelacionada($event)">
    </app-reforma-tributo-regras-relacionadas-section>

    }

</div>
